"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerTable = void 0;
exports.registerTable = function (selector, tableOptions) {
    var $table = $(selector);
    // @ts-ignore
    $table.DataTable(tableOptions);
};
